"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = getBooleanType;
exports.BooleanType = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _MixedType2 = require("./MixedType");

var BooleanType = /*#__PURE__*/function (_MixedType) {
  (0, _inheritsLoose2["default"])(BooleanType, _MixedType);

  function BooleanType(errorMessage) {
    var _this;

    _this = _MixedType.call(this, 'boolean') || this;

    _MixedType.prototype.pushRule.call((0, _assertThisInitialized2["default"])(_this), {
      onValid: function onValid(v) {
        return typeof v === 'boolean';
      },
      errorMessage: errorMessage || _this.locale.type
    });

    return _this;
  }

  return BooleanType;
}(_MixedType2.MixedType);

exports.BooleanType = BooleanType;

function getBooleanType(errorMessage) {
  return new BooleanType(errorMessage);
}